module.exports = __webpack_public_path__ + "static/media/value-absolute.abbcf397.svg";